module.exports = __webpack_public_path__ + "media/images/pic/courses/benefit08-1746df26ff6004ecce159741f6a42e00.svg";